import API from '../lib/API';
import { GenerateStats } from './contracts/Stats.contract';

const route = '/overview/stats';

export function generateStats(filters: GenerateStats.Data): Promise<GenerateStats.Response> {
    return API.post(route, filters);
};